<div class="auth-providers">
  <!-- Loading indicator -->
  <div *ngIf="showProgress" class="loading-container">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <ng-container *ngIf="!isLoading">
    <div class="alert alert-info" *ngIf="!isWebMode"
         i18n="@@section.signInMethods.webOnlyInfo">
      Linking and unlinking log-in methods is currently only possible using the web version.
    </div>

    <h3 class="section-title" i18n="@@section.signInMethods.activeMethods">Active log-in methods</h3>

    <div class="provider-list">
      <div *ngFor="let p of linkedProviders" class="provider-card">
        <div class="provider-header">
          <div class="provider-title">
            <mat-icon *ngIf="p.icon" [svgIcon]="p.icon" class="provider-icon"></mat-icon>
            <span>{{ p.name }}</span>
          </div>
          <button mat-button color="warn"
                  [disabled]="!isWebMode || busyFor === p.id || linkedCount <= 1"
                  (click)="removeSignInMethod(p.id)">
            <mat-icon>link_off</mat-icon>
            <span i18n="@@common.action.remove">Remove</span>
          </button>
        </div>
        <div class="provider-identifier">{{ getProviderIdentifier(p.id) || '-' }}</div>

        <div class="provider-actions" *ngIf="p.id === 'password'">
          <button mat-button color="primary" (click)="openChangeEmailDialog()" [disabled]="!isWebMode || busyChangeEmail || busyFor === p.id">
            <mat-icon>edit</mat-icon>
            <span i18n="@@section.changeEmail">Change email</span>
          </button>
          <button mat-button color="primary" (click)="openChangePasswordDialog()" [disabled]="!isWebMode || busyChangePassword || busyFor === p.id">
            <mat-icon>key</mat-icon>
            <span i18n="@@section.changePassword">Change password</span>
          </button>
        </div>
      </div>
    </div>

    <div class="add-provider" *ngIf="isWebMode">
      <h3 i18n="@@section.signInMethods.addNew">Add another log-in method</h3>
      <div class="add-provider-buttons">
        <button *ngFor="let p of availableProviders"
                mat-stroked-button
                (click)="addSignInMethod(p.id)"
                [disabled]="busyFor === p.id">
          <mat-icon *ngIf="p.icon" [svgIcon]="p.icon"></mat-icon>
          {{ p.name }}
        </button>
      </div>
    </div>
  </ng-container>
</div>
